// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__15Mn8","fileDisabled":"File_fileDisabled__1kjXV"};